module.exports = __webpack_public_path__ + "img/1792492840697.839017eb.png";